import { useLang } from './LanguageContext';
import t from './translations';

export const useT = () => {
  const { lang } = useLang();
  return t[lang] || t.fr;
};
